import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { useIsFramedCentredStep } from '../hooks/useIsFramedCentredStep';
import Separator from '../step-landing-page/Separator';
import { Step } from '../views/Step';
import { OAuthToComponent } from './OAuthMapping';
import { OAuthVerificationFailureText } from './OAuthVerificationFailureText';
import { useOAuthSignup } from './useOAuthSignup';
export const OAuthSignupSection = () => {
  const {
    oAuthsEnabledByFlowConfig,
    atLeastOneOAuthEnabled
  } = useOAuthSignup();
  const {
    isFramedCentredStep
  } = useIsFramedCentredStep();

  const renderOAuths = () => {
    const oAuths = Object.keys(oAuthsEnabledByFlowConfig).filter(oAuth => oAuthsEnabledByFlowConfig[oAuth]).map(oAuth => {
      return /*#__PURE__*/_jsxs("div", {
        children: [OAuthToComponent[oAuth], /*#__PURE__*/_jsx(OAuthVerificationFailureText, {
          oAuth: oAuth
        })]
      }, oAuth);
    });
    return oAuths;
  };

  return /*#__PURE__*/_jsxs("div", {
    className: isFramedCentredStep ? 'm-top-4' : 'm-top-6',
    children: [renderOAuths(), atLeastOneOAuthEnabled && /*#__PURE__*/_jsx(Separator, {
      message: `views.${Step.LandingPage}.separator`
    })]
  });
};